import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button
} from "@mui/material";
import axios from "axios";
import { callAPI, Method } from "../../commonFunctions/CommonFunctions";
import http from "../../commonFunctions/httpClient";

interface ConfirmationPopupProps {
  apiUrl: string;
  id: string | number;
  confirmMessage: string;
  onConfirm?: (data: any) => void;
  onCancel?: () => void;
  open: boolean;
  onClose: () => void;
  permanent?: boolean;
}

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({
  apiUrl,
  id,
  confirmMessage,
  onConfirm,
  onCancel,
  open,
  onClose,
  permanent
}) => {
  const handleConfirm = async () => {
    try {
      const response: any = await http.put(apiUrl + "/" + id, {});
      console.log('response is when soft delete',response)
      if (onConfirm) onConfirm(response);
    } catch (error) {
      console.error("Error deleting:", error);
    } finally {
      onClose();
    }
  };

  const handleConfirmDelete = async () => {
    try {
      const response: any = await http.del(apiUrl + "/" + id, {});
      console.log('response is when delete',response)
      if (onConfirm) onConfirm(response);
    } catch (error) {
      console.error("Error deleting:", error);
    } finally {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent>
        <DialogContentText>{confirmMessage}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel || onClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={permanent ? handleConfirmDelete : handleConfirm}
          color="secondary"
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationPopup;
